module.exports = __webpack_public_path__ + "img/Sj.56a0122a.jpeg";